export const DistributorComparativeSalesPerf = {
    "sections": [
      /*advancedTable Actual vs Last Year Sales*/
      {
        "columns": 2,
        "rows": 1,
        "visual": {
          "id": 14,
          "type": "summary",
          "colorTheme": "colorTheme1",
          "title": "Sales Performance Summary",
          "binding": {
            "data": {
              "title": '',
              "value": '',
              "displayTarget": true,
              "endpoint": "P05",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "DistributorCode", "value": "" },
                { "key": "ConfigTypeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
  
                }
              }
            }
          }
        }
      },
      {
        "columns": 3,
        "rows": 1,
        "visual": {
          "id": 14,
          "type": "pie",
          "colorTheme": "colorTheme1",
          "title": "Share by Region",
          "binding": {
            "data": {
              "title": 'RegionCode',
              "value": 'Share',
              "tooltip": 'ActualSales',
              "currency": true,
              "percent": true,
              "endpoint": "P22",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "DistributorCode", "value": "" },
                { "key": "ConfigTypeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
                  "selectedValueColumn": "RegionCode",
                  "visuals": [
                    {
                      "title": "Region",
                      "visual": [
                        {
                          "columns": 6,
                          "rows": 1,
                          "visual": {
                            "id": 1,
                            "type": "combo",
                            "colorTheme": 'colorTheme2',
                            "title": "Actual vs Target (% Performance)",
                            "orientation": "vertical",
                            "xAxis": "",
                            "yAxis": "",
                            "binding": {
                              "data": {
                                "series": [
                                  {
                                    "name": 'Sales',
                                    "value": 'ActualSales',
                                    "type": 'column'
                                  },
                                  {
                                    "name": 'Target',
                                    "value": 'TargetSales',
                                    "type": 'column'
                                  },
                                  {
                                    "name": 'Performance %',
                                    "value": 'Performance',
                                    "type": 'line',
                                    "percent": true
                                  }
                                ],
                                "title": "RegionCode",
                                "endpoint": "P22.1",
                                "parameters": [
                                  { "key": "FromMonth", "value": "2024" },
                                  { "key": "FromYear", "value": "1" },
                                  { "key": "ToMonth", "value": "2024" },
                                  { "key": "ToYear", "value": "1" },
                                  { "key": "DistributorCode", "value": "" },
                                  { "key": "RegionCode", "value": "" },
                                  { "key": "ConfigTypeCode", "value": "" }
                                ]
                              },
                              "context": {
                                "point": {
                                  "onClick": {
  
                                  }
                                }
                              }
                            }
                          }
                        },
                        {
                          "columns": 6,
                          "rows": 1,
                          "visual": {
                            "id": 1,
                            "type": "combo",
                            "colorTheme": 'colorTheme1',
                            "title": "Actual Sales vs Last Year (% Growth)",
                            "orientation": "vertical",
                            "xAxis": "",
                            "yAxis": "",
                            "binding": {
                              "data": {
                                "series": [
                                  {
                                    "name": 'Sales',
                                    "value": 'ActualSales',
                                    "type": 'column'
                                  },
                                  {
                                    "name": 'LY Sales',
                                    "value": 'LYSales',
                                    "type": 'column'
                                  },
                                  {
                                    "name": 'Growth %',
                                    "value": 'Growth',
                                    "type": 'line',
                                    "percent": true
                                  }
                                ],
                                "title": "RegionCode",
                                "endpoint": "P22.1",
                                "parameters": [
                                  { "key": "FromMonth", "value": "2024" },
                                  { "key": "FromYear", "value": "1" },
                                  { "key": "ToMonth", "value": "2024" },
                                  { "key": "ToYear", "value": "1" },
                                  { "key": "DistributorCode", "value": "" },
                                  { "key": "RegionCode", "value": "" },
                                  { "key": "ConfigTypeCode", "value": "" }
                                ]
                              },
                              "context": {
                                "point": {
                                  "onClick": {
  
                                  }
                                }
                              }
                            }
                          }
  
                        },
                        {
                          "columns": 6,
                          "rows": 1,
                          "visual": {
                            "id": 1,
                            "type": "combo",
                            "colorTheme": 'colorTheme2',
                            "title": "Comparative Monthly (Actual Vs. Target)",
                            "orientation": "vertical",
                            "xAxis": "",
                            "yAxis": "",
                            "binding": {
                              "data": {
                                "series": [
                                  {
                                    "name": 'Sales',
                                    "value": 'ActualSales',
                                    "type": 'column'
                                  },
                                  {
                                    "name": 'Target',
                                    "value": 'TargetSales',
                                    "type": 'column'
                                  },
                                  {
                                    "name": 'Performance %',
                                    "value": 'Performance',
                                    "type": 'line',
                                    "percent": true
                                  }
                                ],
                                "title": "Month",
                                "endpoint": "P22.2",
                                "parameters": [
                                  { "key": "FromMonth", "value": "2024" },
                                  { "key": "FromYear", "value": "1" },
                                  { "key": "ToMonth", "value": "2024" },
                                  { "key": "ToYear", "value": "1" },
                                  { "key": "DistributorCode", "value": "" },
                                  { "key": "RegionCode", "value": "" },
                                  { "key": "ConfigTypeCode", "value": "" }
                                ]
                              },
                              "context": {
                                "point": {
                                  "onClick": {
  
                                  }
                                }
                              }
                            }
                          }
                        },
                        {
                          "columns": 6,
                          "rows": 1,
                          "visual": {
                            "id": 1,
                            "type": "combo",
                            "colorTheme": 'colorTheme1',
                            "title": "Comparative Monthly (Last Year vs Actual Sales)",
                            "orientation": "vertical",
                            "xAxis": "",
                            "yAxis": "",
                            "binding": {
                              "data": {
                                "series": [
                                  {
                                    "name": 'Sales',
                                    "value": 'ActualSales',
                                    "type": 'column'
                                  },
                                  {
                                    "name": 'LY Sales',
                                    "value": 'LYSales',
                                    "type": 'column'
                                  },
                                  {
                                    "name": 'Growth %',
                                    "value": 'Growth',
                                    "type": 'line',
                                    "percent": true
                                  }
                                ],
                                "title": "Month",
                                "endpoint": "P22.2",
                                "parameters": [
                                  { "key": "FromMonth", "value": "2024" },
                                  { "key": "FromYear", "value": "1" },
                                  { "key": "ToMonth", "value": "2024" },
                                  { "key": "ToYear", "value": "1" },
                                  { "key": "DistributorCode", "value": "" },
                                  { "key": "RegionCode", "value": "" },
                                  { "key": "ConfigTypeCode", "value": "" }
                                ]
                              },
                              "context": {
                                "point": {
                                  "onClick": {
  
                                  }
                                }
                              }
                            }
                          }
                        }
                      ]
                    },
                    {
                      "title": "District",
                      "visual": [
                        {
                          "columns": 6,
                          "rows": 2,
                          "visual": {
                            "id": 1,
                            "type": "combo",
                            "colorTheme": 'colorTheme2',
                            "title": "Actual vs Target (% Performance)",
                            "orientation": "vertical",
                            "xAxis": "",
                            "yAxis": "",
                            "binding": {
                              "data": {
                                "series": [
                                  {
                                    "name": 'Sales',
                                    "value": 'ActualSales',
                                    "type": 'column'
                                  },
                                  {
                                    "name": 'Target',
                                    "value": 'TargetSales',
                                    "type": 'column'
                                  },
                                  {
                                    "name": 'Performance %',
                                    "value": 'Performance',
                                    "type": 'line',
                                    "percent": true
                                  }
                                ],
                                "title": "DistrictManagerName",
                                "endpoint": "P22.3",
                                "parameters": [
                                  { "key": "FromMonth", "value": "2024" },
                                  { "key": "FromYear", "value": "1" },
                                  { "key": "ToMonth", "value": "2024" },
                                  { "key": "ToYear", "value": "1" },
                                  { "key": "RegionCode", "value": "" },
                                  { "key": "DistributorCode", "value": "" },
                                  { "key": "ConfigTypeCode", "value": "" }
                                ]
                              },
                              "context": {
                                "point": {
                                  "onClick": {
                                    "selectedValueColumn": "RegionCodeDistrictManagerName",
                                    "selectedTitle": "Comparative Monthly Performance",
                                    "visual": [
                                      {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                          "id": 1,
                                          "type": "combo",
                                          "colorTheme": 'colorTheme2',
                                          "title": "Actual vs Target (% Performance)",
                                          "orientation": "vertical",
                                          "xAxis": "",
                                          "yAxis": "",
                                          "binding": {
                                            "data": {
                                              "series": [
                                                {
                                                  "name": 'Sales',
                                                  "value": 'ActualSales',
                                                  "type": 'column'
                                                },
                                                {
                                                  "name": 'Target',
                                                  "value": 'TargetSales',
                                                  "type": 'column'
                                                },
                                                {
                                                  "name": 'Performance %',
                                                  "value": 'Performance',
                                                  "type": 'line',
                                                  "percent": true
                                                }
                                              ],
                                              "title": "Month",
                                              "endpoint": "P22.4",
                                              "parameters": [
                                                { "key": "FromMonth", "value": "2024" },
                                                { "key": "FromYear", "value": "1" },
                                                { "key": "ToMonth", "value": "2024" },
                                                { "key": "ToYear", "value": "1" },
                                                { "key": "DistributorCode", "value": "" },
                                                { "key": "RegionCodeDistrictManagerName", "value": '' },
                                                { "key": "ConfigTypeCode", "value": "" }
                                              ]
                                            },
                                            "context": {
                                              "point": {
                                                "onClick": {
  
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    ]
                                  }
                                }
                              }
                            }
                          }
                        },
                        {
                          "columns": 6,
                          "rows": 2,
                          "visual": {
                            "id": 1,
                            "type": "combo",
                            "colorTheme": 'colorTheme1',
                            "title": "Actual Sales vs Last Year (% Growth)",
                            "orientation": "vertical",
                            "xAxis": "",
                            "yAxis": "",
                            "binding": {
                              "data": {
                                "series": [
                                  {
                                    "name": 'Sales',
                                    "value": 'ActualSales',
                                    "type": 'column'
                                  },
                                  {
                                    "name": 'LY Sales',
                                    "value": 'LYSales',
                                    "type": 'column'
                                  },
                                  {
                                    "name": 'Growth %',
                                    "value": 'Growth',
                                    "type": 'line',
                                    "percent": true
                                  }
  
                                ],
                                "title": "DistrictManagerName",
                                "endpoint": "P22.3",
                                "parameters": [
                                  { "key": "FromMonth", "value": "2024" },
                                  { "key": "FromYear", "value": "1" },
                                  { "key": "ToMonth", "value": "2024" },
                                  { "key": "ToYear", "value": "1" },
                                  { "key": "RegionCode", "value": "" },
                                  { "key": "DistributorCode", "value": "" },
                                  { "key": "ConfigTypeCode", "value": "" }
                                ]
                              },
                              "context": {
                                "point": {
                                  "onClick": {
                                    "selectedValueColumn": "RegionCodeDistrictManagerName",
                                    "selectedTitle": "Comparative Monthly Growth",
                                    "visual": [
                                      {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                          "id": 1,
                                          "type": "combo",
                                          "colorTheme": 'colorTheme2',
                                          "title": "% Growth ( This Year Vs Last Year )",
                                          "xAxis": "",
                                          "yAxis": "",
                                          "binding": {
                                            "data": {
                                              "series": [
                                                {
                                                  "name": 'Sales',
                                                  "value": 'ActualSales',
                                                  "type": 'column'
                                                },
                                                {
                                                  "name": 'LY Sales',
                                                  "value": 'LYSales',
                                                  "type": 'column'
                                                },
                                                {
                                                  "name": 'Growth %',
                                                  "value": 'Growth',
                                                  "type": 'line',
                                                  "percent": true
                                                }
                                              ],
                                              "title": "Month",
                                              "endpoint": "P22.4",
                                              "parameters": [
                                                { "key": "FromMonth", "value": "2024" },
                                                { "key": "FromYear", "value": "1" },
                                                { "key": "ToMonth", "value": "2024" },
                                                { "key": "ToYear", "value": "1" },
                                                { "key": "DistributorCode", "value": "" },
                                                { "key": "RegionCodeDistrictManagerName", "value": '' },
                                                { "key": "ConfigTypeCode", "value": "" }
                                              ]
                                            },
                                            "context": {
                                              "point": {
                                                "onClick": {
  
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    ]
                                  }
                                }
                              }
                            }
                          }
                        }
                      ]
                    },
                    {
                      "title": "Territory Manager",
                      "visual": [
                        {
                          "columns": 12,
                          "rows": 2,
                          "visual": {
                            "id": 1,
                            "type": "combo",
                            "colorTheme": 'colorTheme2',
                            "title": "Actual vs Target (% Performance)",
                            "orientation": "vertical",
                            "xAxis": "",
                            "yAxis": "",
                            "binding": {
                              "data": {
                                "series": [
                                  {
                                    "name": 'Sales',
                                    "value": 'ActualSales',
                                    "type": 'column'
                                  },
                                  {
                                    "name": 'Target',
                                    "value": 'TargetSales',
                                    "type": 'column'
                                  },
                                  {
                                    "name": 'Performance %',
                                    "value": 'Performance',
                                    "type": 'line',
                                    "percent": true
                                  }
                                ],
                                "title": "AgentName",
                                "endpoint": "P22.5",
                                "parameters": [
                                  { "key": "FromMonth", "value": "2024" },
                                  { "key": "FromYear", "value": "1" },
                                  { "key": "ToMonth", "value": "2024" },
                                  { "key": "ToYear", "value": "1" },
                                  { "key": "RegionCode", "value": "" },
                                  { "key": "DistributorCode", "value": '' },
                                  { "key": "ConfigTypeCode", "value": "" }
                                ]
                              },
                              "context": {
                                "point": {
                                  "onClick": {
                                    "selectedValueColumn": "RegionCodeAgentName",
                                    "selectedTitle": "Comparative Monthly Performance",
                                    "visual": [
                                      {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                          "id": 1,
                                          "type": "combo",
                                          "colorTheme": 'colorTheme2',
                                          "title": "Actual vs Target (% Performance)",
                                          "orientation": "vertical",
                                          "xAxis": "",
                                          "yAxis": "",
                                          "binding": {
                                            "data": {
                                              "series": [
                                                {
                                                  "name": 'Sales',
                                                  "value": 'ActualSales',
                                                  "type": 'column'
                                                },
                                                {
                                                  "name": 'Target',
                                                  "value": 'TargetSales',
                                                  "type": 'column'
                                                },
                                                {
                                                  "name": 'Performance %',
                                                  "value": 'Performance',
                                                  "type": 'line',
                                                  "percent": true
                                                }
                                              ],
                                              "title": "Month",
                                              "endpoint": "P22.6",
                                              "parameters": [
                                                { "key": "FromMonth", "value": "2024" },
                                                { "key": "FromYear", "value": "1" },
                                                { "key": "ToMonth", "value": "2024" },
                                                { "key": "ToYear", "value": "1" },
                                                { "key": "DistributorCode", "value": '' },
                                                { "key": "RegionCodeAgentName", "value": '' },
                                                { "key": "ConfigTypeCode", "value": "" }
                                              ]
                                            },
                                            "context": {
                                              "point": {
                                                "onClick": {
  
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    ]
                                  }
                                }
                              }
                            }
                          }
                        },
                        {
                          "columns": 12,
                          "rows": 2,
                          "visual": {
                            "id": 1,
                            "type": "combo",
                            "colorTheme": 'colorTheme1',
                            "title": "Actual Sales vs Last Year (% Growth)",
                            "orientation": "vertical",
                            "xAxis": "",
                            "yAxis": "",
                            "binding": {
                              "data": {
                                "series": [
                                  {
                                    "name": 'Sales',
                                    "value": 'ActualSales',
                                    "type": 'column'
                                  },
                                  {
                                    "name": 'LY Sales',
                                    "value": 'LYSales',
                                    "type": 'column'
                                  },
                                  {
                                    "name": 'Growth %',
                                    "value": 'Growth',
                                    "type": 'line',
                                    "percent": true
                                  }
                                ],
                                "title": "AgentName",
                                "endpoint": "P22.5",
                                "parameters": [
                                  { "key": "FromMonth", "value": "2024" },
                                  { "key": "FromYear", "value": "1" },
                                  { "key": "ToMonth", "value": "2024" },
                                  { "key": "ToYear", "value": "1" },
                                  { "key": "RegionCode", "value": "" },
                                  { "key": "DistributorCode", "value": '' },
                                  { "key": "ConfigTypeCode", "value": "" }
                                ]
                              },
                              "context": {
                                "point": {
                                  "onClick": {
                                    "selectedValueColumn": "RegionCodeAgentName",
                                    "selectedTitle": "Comparative Monthly Growth",
                                    "visual": [
                                      {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                          "id": 1,
                                          "type": "bar",
                                          "colorTheme": 'colorTheme1',
                                          "title": "This Year vs Last Year (% Growth)",
                                          "orientation": "vertical",
                                          "xAxis": "",
                                          "yAxis": "",
                                          "binding": {
                                            "data": {
                                              "series": [
                                                {
                                                  "name": 'Sales',
                                                  "value": 'ActualSales',
                                                  "type": 'column'
                                                },
                                                {
                                                  "name": 'LY Sales',
                                                  "value": 'LYSales',
                                                  "type": 'column'
                                                },
                                                {
                                                  "name": 'Growth %',
                                                  "value": 'Growth',
                                                  "type": 'line'
                                                }
                                              ],
                                              "title": "Month",
                                              "endpoint": "P22.6",
                                              "parameters": [
                                                { "key": "FromMonth", "value": "2024" },
                                                { "key": "FromYear", "value": "1" },
                                                { "key": "ToMonth", "value": "2024" },
                                                { "key": "ToYear", "value": "1" },
                                                { "key": "DistributorCode", "value": '' },
                                                { "key": "RegionCodeAgentName", "value": '' },
                                                { "key": "ConfigTypeCode", "value": "" }
                                              ]
                                            },
                                            "context": {
                                              "point": {
                                                "onClick": {
  
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    ]
                                  }
                                }
                              }
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              }
            }
          }
        }
      },
      {
        "columns": 3,
        "rows": 1,
        "visual": {
          "id": 4,
          "type": "treemap",
          "colorTheme": "colorTheme1",
          "title": "Share by District",
          "xAxis": "",
          "yAxis": "",
          "binding": {
            "data": {
              "title": 'DistrictGroupCode',
              "value": 'Share',
              "tooltip": 'ActualSales',
              "currency": true,
              "percent": true,
              "endpoint": "P23",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "ConfigTypeCode", "value": "" },
                { "key": "DistributorCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
                  "selectedValueColumn": "DistrictGroupCode",
                  "selectedTitle": "District Manager",
                  "visual": [
                    {
                      "columns": 12,
                      "rows": 2,
                      "visual": {
                        "id": 1,
                        "type": "advancedTable",
                        "colorTheme": 'colorTheme1',
                        "title": "District Manager",
                        "binding": {
                          "data": {
                            "columns": [
                              {
                                "name": 'District Manager Name',
                                "columnName": 'DistrictManagerName',
                                "width": '200px',
                                "align": "left",
                                "sortable": true,
                                "sum": false,
                              },
                              {
                                "name": 'Actual Sales',
                                "columnName": 'ActualSales',
                                "width": '140px',
                                "align": "right",
                                "sortable": true,
                                "sum": true,
                              },
                              {
                                "name": 'LY Sales',
                                "columnName": 'LYSales',
                                "width": '125px',
                                "align": "right",
                                "sortable": true,
                                "sum": true,
                              },
                              {
                                "name": 'Growth %',
                                "columnName": 'Growth',
                                "width": '125px',
                                "align": "right",
                                "sortable": true,
                                "sum": false,
                                "percent": true
                              },
                              {
                                "name": 'Target',
                                "columnName": 'TargetSales',
                                "width": '125px',
                                "align": "right",
                                "sortable": true,
                                "sum": true,
                              },
                              {
                                "name": 'Performance %',
                                "columnName": 'Performance',
                                "width": '150px',
                                "align": "right",
                                "sortable": true,
                                "sum": false,
                                "percent": true
                              }
                            ],
                            "title": "DistrictManagerName",
                            "endpoint": "P23.1",
                            "parameters": [
                              { "key": "FromMonth", "value": "2024" },
                              { "key": "FromYear", "value": "1" },
                              { "key": "ToMonth", "value": "2024" },
                              { "key": "ToYear", "value": "1" },
                              { "key": "DistrictGroupCode", "value": "" },
                              { "key": "DistributorCode", "value": "" },
                              { "key": "ConfigTypeCode", "value": "" }
                            ]
                          },
                          "context": {
                            "point": {
                              "onClick": {
                                "selectedValueColumn": "DistrictGroupCodeDistrictManagerName",
                                "selectedTitle": "Territory Manager",
                                "visual": [
                                  {
                                    "columns": 12,
                                    "rows": 2,
                                    "visual": {
                                      "id": 1,
                                      "type": "advancedTable",
                                      "colorTheme": 'colorTheme1',
                                      "title": "Territory Manager",
                                      "binding": {
                                        "data": {
                                          "columns": [
                                            {
                                              "name": 'Territory Manager Name',
                                              "columnName": 'AgentName',
                                              "width": '200px',
                                              "align": "left",
                                              "sortable": true,
                                              "sum": false,
                                            },
                                            {
                                              "name": 'Actual Sales',
                                              "columnName": 'ActualSales',
                                              "width": '140px',
                                              "align": "right",
                                              "sortable": true,
                                              "sum": true,
                                            },
                                            {
                                              "name": 'LY Sales',
                                              "columnName": 'LYSales',
                                              "width": '125px',
                                              "align": "right",
                                              "sortable": true,
                                              "sum": true,
                                            },
                                            {
                                              "name": 'Growth %',
                                              "columnName": 'Growth',
                                              "width": '125px',
                                              "align": "right",
                                              "sortable": true,
                                              "sum": false,
                                              "percent": true
                                            },
                                            {
                                              "name": 'Target',
                                              "columnName": 'TargetSales',
                                              "width": '125px',
                                              "align": "right",
                                              "sortable": true,
                                              "sum": true,
                                            },
                                            {
                                              "name": 'Performance %',
                                              "columnName": 'Performance',
                                              "width": '150px',
                                              "align": "right",
                                              "sortable": true,
                                              "sum": false,
                                              "percent": true
                                            }
                                          ],
                                          "title": "AgentName",
                                          "endpoint": "P23.2",
                                          "parameters": [
                                            { "key": "FromMonth", "value": "2024" },
                                            { "key": "FromYear", "value": "1" },
                                            { "key": "ToMonth", "value": "2024" },
                                            { "key": "ToYear", "value": "1" },
                                            { "key": "DistributorCode", "value": "" },
                                            { "key": "DistrictGroupCodeDistrictManagerName", "value": "" },
                                            { "key": "ConfigTypeCode", "value": "" }
                                          ]
                                        },
                                        "context": {
                                          "point": {
                                            "onClick": {
  
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                ]
                              }
                            }
                          }
                        }
                      }
                    }
                  ]
                }
              }
            }
          }
        }
      },
      {
        "columns": 4,
        "rows": 3,
        "visual": {
          "id": 1,
          "type": "bar",
          "title": "Product Sales",
          "colorTheme": 'colorTheme2',
          "orientation": "horizontal",
          "xAxis": "Sales",
          "yAxis": "",
          "binding": {
            "data": {
              "series": [
                {
                  "name": 'Sales',
                  "value": 'ActualSales',
                  "type": 'column'
                }
              ],
              "title": "ItemName",
              "endpoint": "P25",
              "parameters": [
                { "key": "FromMonth", "value": "" },
                { "key": "FromYear", "value": "" },
                { "key": "ToMonth", "value": "" },
                { "key": "ToYear", "value": "" },
                { "key": "DistributorCode", "value": "" },
                { "key": "ConfigTypeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
                  "selectedValueColumn": "ItemName",
                  "selectedTitle": "Customer Group",
                  "visual": [
                    {
                      "columns": 12,
                      "rows": 3,
                      "visual": {
                        "id": 1,
                        "type": "bar",
                        "title": "Customer Group",
                        "colorTheme": 'colorTheme2',
                        "orientation": "horizontal",
                        "xAxis": "Sales",
                        "yAxis": "",
                        "binding": {
                          "data": {
                            "series": [
                              {
                                "name": 'Sales',
                                "value": 'ActualSales',
                                "type": 'column'
                              }
                            ],
                            "title": "CustomerGroup",
                            "endpoint": "P25.1",
                            "parameters": [
                              { "key": "FromMonth", "value": "" },
                              { "key": "FromYear", "value": "" },
                              { "key": "ToMonth", "value": "" },
                              { "key": "ToYear", "value": "" },
                              { "key": "ItemName", "value": "" },
                              { "key": "DistributorCode", "value": "" },
                              { "key": "ConfigTypeCode", "value": "" }
                            ]
                          },
                          "context": {
                            "point": {
                              "onClick": {
  
                              }
                            }
                          }
                        }
                      }
                    }
                  ]
                }
              }
            }
          }
        }
      },
      {
        "columns": 4,
        "rows": 1,
        "visual": {
          "id": 1,
          "type": "combo",
          "colorTheme": 'colorTheme1',
          "title": "Actual Sales vs Last Year (% Growth)",
          "orientation": "vertical",
          "xAxis": "",
          "yAxis": "",
          "binding": {
            "data": {
              "series": [
  
                {
                  "name": 'Sales',
                  "value": 'ActualSales',
                  "type": 'column'
                },
                {
                  "name": 'LY Sales',
                  "value": 'LYSales',
                  "type": 'column'
                },
                {
                  "name": 'Growth %',
                  "value": 'Growth',
                  "type": 'line',
                  "percent": true
                }
              ],
              "title": "Month",
              "endpoint": "P06",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "ConfigTypeCode", "value": "" },
                { "key": "DistributorCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
  
                }
              }
            }
          }
        }
      },
      {
        "columns": 4,
        "rows": 2,
        "visual": {
          "id": 1,
          "type": "bar",
          "title": "Customer Group Sales",
          "colorTheme": 'colorTheme2',
          "orientation": "horizontal",
          "xAxis": "Sales",
          "yAxis": "",
          "binding": {
            "data": {
              "series": [
                {
                  "name": 'Sales',
                  "value": 'ActualSales',
                  "type": 'column'
                }
              ],
              "title": "CustomerGroup",
              "endpoint": "P25.2",
              "parameters": [
                { "key": "FromMonth", "value": "" },
                { "key": "FromYear", "value": "" },
                { "key": "ToMonth", "value": "" },
                { "key": "ToYear", "value": "" },
                { "key": "DistributorCode", "value": "" },
                { "key": "ConfigTypeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
                  "selectedValueColumn": "CustomerGroup",
                  "selectedTitle": "Product",
                  "visual": [
                    {
                      "columns": 12,
                      "rows": 3,
                      "visual": {
                        "id": 1,
                        "type": "bar",
                        "title": "Products",
                        "colorTheme": 'colorTheme2',
                        "orientation": "horizontal",
                        "xAxis": "Sales",
                        "yAxis": "",
                        "binding": {
                          "data": {
                            "series": [
                              {
                                "name": 'Sales',
                                "value": 'ActualSales',
                                "type": 'column'
                              }
                            ],
                            "title": "ItemName",
                            "endpoint": "P25.3",
                            "parameters": [
                              { "key": "FromMonth", "value": "" },
                              { "key": "FromYear", "value": "" },
                              { "key": "ToMonth", "value": "" },
                              { "key": "ToYear", "value": "" },
                              { "key": "DistributorCode", "value": "" },
                              { "key": "CustomerGroup", "value": "" },
                              { "key": "ConfigTypeCode", "value": "" }
                            ]
                          },
                          "context": {
                            "point": {
                              "onClick": {
  
                              }
                            }
                          }
                        }
                      }
                    }
                  ]
                }
              }
            }
          }
        }
      },
      {
        "columns": 4,
        "rows": 1,
        "visual": {
          "id": 1,
          "type": "advancedTable",
          "colorTheme": "colorTheme1",
          "title": "Territory Sales",
          "binding": {
            "data": {
              "columns": [
                {
                  "name": 'Territory Manager Name',
                  "columnName": 'AgentName',
                  "width": '250px',
                  "align": "left",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": 'Actual Sales',
                  "columnName": 'ActualSales',
                  "width": '140px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                }
              ],
              "title": 'AgentName',
              "endpoint": "P24",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "DistributorCode", "value": "" },
                { "key": "ConfigTypeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
  
                }
              }
            }
          }
        }
      }
    ]
  }